import React from 'react';
import { Row, Col, Card, CardHeader, CardBody, Button } from 'reactstrap';
import { useUser } from 'context/UserContext';

export default function Honorarios() {
  const { getMatricula } = useUser();
  const matriculateId = getMatricula();
  if (!matriculateId) {
    return null;
  }

  const HONORARIOS_URL = `https://honorarios.autogestion.cokiba.org.ar/?matricula=${matriculateId}`;

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <h4 className="title">Honorarios</h4>
            </CardHeader>
            <CardBody>
              <p>Visualizar tus Honorarios</p>
              <Button
                color="primary"
                href={HONORARIOS_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Ver Honorarios
              </Button>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
